import { apiGet } from '@/store/api';
import type { GatResponseResult } from '@/types/GatResponseResult';
import type { EnquiryListItem } from '@/types/ProformaTypes';

export interface AgencyProformaRequestResponse {
    proformas: EnquiryListItem[];
}

/** This function retrieves agency proformas based on the provided agency ID.  */
export async function getAgencyProformas(
    agencyId: string | number,
    fromDate: string, toDate: string, includeClosed: boolean
): Promise<GatResponseResult<AgencyProformaRequestResponse>> {
    const queryString = `?FromDate=${fromDate}&ToDate=${toDate}&IncludeClosed=${includeClosed}`;
    const response = (await apiGet(
        `proforma/agency/${agencyId}${queryString}`,
    )) as unknown as GatResponseResult<AgencyProformaRequestResponse>;
    return response;
}
